<template>
    <v-content :style="mini  ? 'padding: 0px 0px 0px 80px;' : 'padding: 0px 0px 0px 256px;'" >
        <v-container class="mt-8" fluid>
          <v-row>
            <v-col cols="12">
                <v-card raised>
                  <v-card-item>
                    <v-card-title>{{ documentsdata.gendoc_name }}</v-card-title>
                    <v-card-text>
                      <p>{{ documentsdata.gendoc_description}}</p>
                    </v-card-text>
                  </v-card-item>

  
                  
                    <div v-if="this.documentsdata.gendoc_format == 'pdf' || this.documentsdata.gendoc_format == 'video'">

                      <v-row>
                        <v-col cols="12" sm="12">
                          <div id="downloadbutton">
                          </div>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12">
                          <div  class="iframe-container" style="overflow: hidden; padding-top: 47.00%; position: relative;">
                            <iframe v-if="dialogstatus==false && fileURL != null" id="iframemodule" :src="fileURL+'#toolbar=0'" style="border: 0;height: 100%;left: 0; position: absolute; top: 0; width: 100%;" allowfullscreen></iframe>   
                          </div>               
                        </v-col>
                      </v-row>

                    </div>

                    <div v-if="this.documentsdata.gendoc_format == 'external_url'">
                      <v-card-actions>
                        <v-btn small class="ml-6 white--text" color="primary" :href="fileURL" target="_blank">{{ 'Go to URL'| translate }}</v-btn>
                      </v-card-actions>
                    </div>

                    <div id="imageContainer" class="pa-4"></div>


                </v-card>   
            </v-col>
          </v-row>             
        </v-container>
        <Dialogbox
          @redirect="redirect"
          :title="dialogboxtitle"
          :dialog="dialogstatus"
          :buttonTitle="dialogButtontitle"
          :closestatus='false'
          :redirect="true"
          v-if="dialogstatus == true"
        />

    </v-content>   
</template>
<script>
import {
  FETCH_DOCUMENT,
  DOWNLOAD_GENERAL_DOCUMENT,
  RESET_STATE
} from "@/store/actions.type";
import { SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type";
import store from "@/store";
import { mapGetters } from "vuex";
export default {
  name: "Documentsdetail",
  async beforeRouteEnter(to, from, next) {
    Promise.all([
       await store.dispatch(RESET_STATE),
       await store.dispatch(FETCH_DOCUMENT, to.params.id),
    ]).finally(() => {
      store.commit(SET_LOADING, false)
      store.commit(SET_ROUTER_ENTER, false)

    });

    return next();
  }, 
  components: {
    Dialogbox: () => import("@/components/dialog/dialog")
  },  
  computed: {
    ...mapGetters(['documentsdata', 'mini', 'widthValue']),
  }, 
  data (){
      return {
          file: null,
          fileURL: null,
          dialogstatus: false,
          dialogButtontitle: null,
          dialogboxtitle: null,
      }
  },
  mounted () {
      if(this.documentsdata.gendoc_format == 'pdf' || this.documentsdata.gendoc_format == 'other'){
        this.$store.dispatch(DOWNLOAD_GENERAL_DOCUMENT, 'view-file/'+this.documentsdata.doc_files[0].docfile_id).then(async resp =>{
          if(resp != undefined && resp.hasOwnProperty('success') == false){
            if(this.documentsdata.doc_files[0].extension == 'pdf'){
            this.file = new Blob([resp.data], {type: 'application/pdf'});
            this.fileURL = URL.createObjectURL(this.file);

            const downloadButtonContainer = document.getElementById('downloadbutton');

            // Create a button element
            const downloadButton = document.createElement('v-btn');
            // Define a string with multiple classes
            const combinedClasses = 'mr-6 mb-4 white--text v-btn v-btn--contained theme--light v-size--small primary float-right';

            // Add the combined classes using the class attribute
            downloadButton.setAttribute('class', combinedClasses);
            downloadButton.textContent = 'Download';
            downloadButton.addEventListener('click', () => {
              // Create an anchor element for downloading
              const downloadLink = document.createElement('a');
              downloadLink.href = this.fileURL;
              downloadLink.setAttribute('download', ((this.documentsdata.doc_files[0].file).split('/').pop()) +'.'+this.documentsdata.doc_files[0].extension); // Set the desired download filename
              downloadLink.style.display = 'none'; // Hide the anchor element
              document.body.appendChild(downloadLink);

              // Trigger a click event on the anchor element to start the download
              downloadLink.click();

              // Remove the anchor element from the document
              document.body.removeChild(downloadLink);
            });
            downloadButtonContainer.appendChild(downloadButton);

            await this.$store.commit(SET_LOADING, false)                  
            }
            else if(['doc','docx','ppt','pptx', 'xlsx', 'gif'].includes(this.documentsdata.doc_files[0].extension)){
              let file = null;
              if(['ppt','pptx'].includes(this.documentsdata.doc_files[0].extension)){
                file = new Blob([resp.data], {type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation'});
              }
              else if(['doc','docx'].includes(this.documentsdata.doc_files[0].extension)){
                file = new Blob([resp.data], {type: 'application/msword'});
              }
              else if(['xlsx'].includes(this.documentsdata.doc_files[0].extension)){
                file = new Blob([resp.data], {type: 'application/octet-stream'});
              } 
              else if (['gif'].includes(this.documentsdata.doc_files[0].extension)) {
                file = new Blob([resp.data], { type: 'image/gif' });
              }            
              this.fileURL = URL.createObjectURL(file);
              let fileLink = document.createElement('a');
              fileLink.href = this.fileURL;
              fileLink.setAttribute('download', ((this.documentsdata.doc_files[0].file).split('/').pop()) +'.'+this.documentsdata.doc_files[0].extension);
              document.body.appendChild(fileLink);
              fileLink.click(); 

              await this.$store.commit(SET_LOADING, false)  
            }
            else if(['png','jpg','jpeg'].includes(this.documentsdata.doc_files[0].extension)){
              this.fileURL = URL.createObjectURL(resp.data);                  
             
              let fileLink = document.createElement('a');
              fileLink.href = this.fileURL;
              fileLink.setAttribute('download', this.documentsdata.doc_files[0].doc_type+'.'+this.documentsdata.doc_files[0].extension);
              document.body.appendChild(fileLink);
              // fileLink.click(); //If needed to download uncomment this line of code

              // Create an <img> element and set its 'src' attribute to the data URL
              const imageElement = document.createElement('img');
              imageElement.src = this.fileURL;
              imageElement.alt = 'Image from Blob Data';
              imageElement.style.width = '90%';
              const imageContainer = document.getElementById('imageContainer');
              imageContainer.appendChild(imageElement);

              await this.$store.commit(SET_LOADING, false)                    
            }
            
          }
          else {
            this.dialogstatus=true
            this.dialogboxtitle = 'Please subscribe to course'
            this.dialogButtontitle  = 'Go to courses'
            await this.$store.commit(SET_LOADING, false)   
                           

          }
        })
      }
      else if(this.documentsdata.gendoc_format == 'video'){
          this.fileURL =   this.documentsdata.doc_files[0].file
      }
      else if(this.documentsdata.gendoc_format == 'external_url'){
          this.fileURL =   this.documentsdata.doc_files[0].file
      }
  },
  methods: {
    redirect(){
      this.$router.push('/courses')
    }
  }
}
</script>